const ttlDev = 300000; // 5 min for dev work
const ttlPrd = 3600000; // 1 hour for prod

// Function to fetch data from the API with cache
export const fetchWithCache = async (url: string, options: RequestInit, leagueIdPlatform: string, userId: string, authId: string, forceRefresh = false, ttl: number = ttlPrd) => {
  // Check if the Cache API is available
  const isCacheAvailable = "caches" in window;

  // If the Cache API is not available, return the data from the API
  if (!isCacheAvailable) {
    const errorMessage = "Cache API not available in this environment";
    console.log(errorMessage);
    return { data: null, fromCache: false, ok: false };
  }
  // Create a unique key using the IDs we received as parameters
  const cacheKey = `${url}-${leagueIdPlatform}-${userId}-${authId}`;

  try {
    // Check if the Cache API is available
    if (!("caches" in window)) {
      console.warn("Cache API not available");
      const response = await fetch(url, options);
      const data = await response.json();
      return { data, fromCache: false, ok: response.ok };
    }

    // Open the Cache API
    const cache = await caches.open("api-cache");
    if (forceRefresh) {
      // If forceRefresh is true, we delete the existing cache entry.
      await cache.delete(cacheKey);
    } else {
      // Check if the data is cached
      const cached = await cache.match(cacheKey);

      // Log the cache status
      // console.log("Cache status: ", cacheKey, {
      //   url,
      //   teamInfo: `${leagueIdPlatform}-${userId}`,
      //   hasCached: !!cached,
      //   timestamp: cached?.headers.get("timestamp") ? new Date(Number(cached.headers.get("timestamp"))).toLocaleTimeString("es-ES", { hour12: false }) : undefined,
      //   currentTime: new Date(Date.now()).toLocaleTimeString("es-ES", { hour12: false }),
      // });

      // If the data is cached, return the data from the cache
      if (cached) {
        // Get the data from the cache
        const data = await cached.json();
        // Get the timestamp from the cache
        const timestamp = cached.headers.get("timestamp");

        // Here is the key - let's check if it's really expiring
        // console.log("Cache expiration check:", cacheKey, {
        //   currentTimestamp: new Date(Date.now()).toLocaleTimeString("es-ES", { hour12: false }),
        //   cacheTimestamp: new Date(Number(timestamp)).toLocaleTimeString("es-ES", { hour12: false }),
        //   timeDifference: `${((Date.now() - Number(timestamp)) / 1000 / 60).toFixed(2)} minutes`,
        //   ttl: `${(ttl / 1000 / 60).toFixed(0)} minutes`,
        //   shouldExpire: Date.now() - Number(timestamp) >= ttl,
        // });

        // Check if the data is still valid
        if (timestamp && Date.now() - Number(timestamp) < ttl) {
          // console.log("Returning cached data for:", cacheKey);
          return { data, fromCache: true, ok: true };
        }
      }
    }

    // Log the cache status
    // console.log("Fetching fresh data for:", cacheKey);
    // Fetch the data from the API
    const response = await fetch(url, options);
    // Get the data from the API
    const data = await response.json();

    // Cache after returning so JSON.stringify does not block first paint
    if (response.ok) {
      const snapshot = data;
      setTimeout(() => {
        try {
          const responseToCache = new Response(JSON.stringify(snapshot), {
            headers: {
              "Content-Type": "application/json",
              timestamp: Date.now().toString(),
            },
          });
          void cache.put(cacheKey, responseToCache).catch((cacheError) => {
            console.error("Error caching response:", cacheError);
          });
        } catch (cacheError) {
          console.error("Error caching response:", cacheError);
        }
      }, 0);
    }

    return { data, fromCache: false, ok: response.ok };
  } catch (error) {
    console.error("Cache/fetch error:", error);
    // If there is an error, return the data from the API
    const response = await fetch(url, options);
    // Get the data from the API
    const data = await response.json();
    // Return the data from the API
    return { data, fromCache: false, ok: response.ok };
  }
};
